const DueDateTypeEnumLowercase = {
  noDueDate: 'noDueDate',
  dynamic: 'dynamic',
  fixed: 'fixed',
  contentDependent: 'contentDependent'
};

export { DueDateTypeEnumLowercase };
export default DueDateTypeEnumLowercase;
